export function removePropertiesFromObject(object, propsToExclude) {
  const curated = Object.entries(object).reduce(
    (acc, [prop, value]) =>
      propsToExclude.includes(prop) ? acc : { ...acc, [prop]: value },
    {},
  )

  return curated
}

export function removeUndefinedProperties(object) {
  const curated = Object.entries(object).reduce(
    (acc, [prop, value]) => (value === undefined ? acc : { ...acc, [prop]: value }),
    {},
  )

  return curated
}

export function deepCopyObject(object) {
  return JSON.parse(JSON.stringify(object))
}
